<template>
  <ion-content>
    <Refresher :myObserver="myObserver" />
    
    <ion-card
      class="card-items"
      v-for="item of computedItems"
      :key="item.id"
      :style="{marginBottom: '8px', marginRight: '10px'}">

      <ion-card-content class="ion-no-padding" :style="{position: 'relative'}">
        <ion-row @click="showItem(item)">
          <ion-col
            size="0.1"
            v-if="statusHeader && item.status && !this.computedStatusAlt"
            :class="statusHeader.markers[item.status.toLowerCase().trim()]"
          />
          <ion-col
            size="0.1"
            v-else-if="statusAltHeader && item.status2 && this.computedStatusAlt"
            :class="statusAltHeader.markers[item.status2.toLowerCase().trim()]"
          />
          <ion-col
            size="0.1"
            v-else
            :class="statusHeader.markers['rascunho']"
          />
          <ion-grid>
            <ion-row >
              <ion-col
              size="8"
              class="ion-justify-content-start ion-no-padding"
              >
                <ion-grid class="ion-no-padding">
                  <ion-row>
                    <!-- Status -->
                    <small v-if="statusHeaderDesc">
                      Status:
                      <strong
                        v-html="item.status"
                        :class="`text--${statusHeader.markers[item.status.toLowerCase().trim()]}`"
                      ></strong>
                    </small>
                  </ion-row>

                  <!-- Title -->
                  <ion-row>
                    <small v-if="titleHeader">
                      {{ titleHeader.label }}:
                      <strong
                        v-html="proccessItem({ item, head: titleHeader })"
                      ></strong>
                    </small>
                  </ion-row>
                </ion-grid>
              </ion-col>
              
              <!-- titleRightHeaders -->
              <ion-col
                size="4"
                class="ion-justify-content-end ion-no-padding ion-align-self-start"
                v-if="titleRightHeaders && titleRightHeaders.length > 0"
              >
                  <small
                    v-for="(tRightHeader, index) of titleRightHeaders"
                    :key="index"
                  >
                    <span
                      v-html="proccessItem({ item, head: tRightHeader })"
                    ></span>
                  </small>
              </ion-col>
            </ion-row>

            <!-- subtitle -->
            <ion-row v-if="subTitleHeader">
              <ion-col
                size="12"
                class="ion-justify-content-start ion-no-padding"
              >
                <small>
                  {{ subTitleHeader.label }}:
                  <strong
                    v-html="proccessItem({ item, head: subTitleHeader })"
                  ></strong>
                </small>
              </ion-col>
            </ion-row>

            <!-- Headers -->
            <ion-row v-for="(head, index) of allHeaders" :key="index">
              <ion-col
                size="12"
                class="ion-justify-content-start ion-no-padding"
              >
                <small>
                  {{ head.label }}:
                  <strong v-html="proccessItem({ item, head })"></strong>
                </small>
              </ion-col>
            </ion-row>
          </ion-grid>
          <!-- <ion-col
            v-if="claims.offline"
            size="2"
            :style="{ padding: '0'}"
            @click="$event.stopPropagation();toggleOffline(item)"
          >
            <ion-icon v-if="item.offline" :icon="wifiOutline" color="primary" size="large"></ion-icon>
            <ion-icon v-else :icon="wifiOutline" color="medium" size="large"></ion-icon>
          </ion-col> -->
        </ion-row>
        <!-- <ion-icon 
          v-if="claims.add && register.includes('SC5') && item.C5_NUM && !item.C5_XPEDORI" 
          :icon="gift" 
          color="primary" 
          :style="{position: 'absolute', right: '0px', bottom: '0px', padding: '8px'}"
          @click="bonifyRegister(item)"/> -->
        <ion-icon 
          v-if="
            claims.delete
            && !isBlocked({ item })
            && item.status
            && ['rascunho', 'erro no envio'].includes(item.status.toLowerCase())
            && !offline
          "
          :icon="trash" color="danger" 
          :style="{position: 'absolute', right: '0px', bottom: '0px', padding: '8px'}"
          @click="presentConfirmRemove(item)" />
      </ion-card-content>
    </ion-card>

    <!-- Loading -->
    <ion-grid v-if="searchAsyncLoading" :style="{height: '50%'}">
      <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
        <ion-col size="12">
          <ion-label :style="{paddingRight: '20px'}">Buscando itens</ion-label>
          <ion-spinner name="dots"></ion-spinner>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- No Data -->
    <ion-grid v-else-if="!loading[register] && computedItems && computedItems.length == 0" :style="{height: '50%'}">
      <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
        <ion-col size="12">
          <ion-label color="danger" v-if="searchInput || searchAsyncInput">A pesquisa por "<strong>{{ searchInput || searchAsyncInput }}</strong>" não retornou registros, confira os filtros selecionados.</ion-label>
          <!-- <ion-label color="danger" v-else-if="isFiltered">Os filtros selecionados não retornaram registros.</ion-label> -->
          <ion-label color="danger" v-else>Sem registros.</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- Scroll Next -->
    <ion-infinite-scroll
      @ionInfinite="updatePage($event)" 
      threshold="50px" 
      id="infinite-scroll"
      :disabled="disableInfiniteScroll">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Carregando">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>

    <ion-fab v-if="claims.add" 
      :class="{ filtered: (searchInput && searchInput.trim() !== '') || (searchAsyncInput && searchAsyncInput.trim() !== '') || (filters && filters.length > 0)}" 
      horizontal="end" vertical="bottom" slot="fixed" animated
    >
      <ion-fab-button @click="callRegister()">
        <ion-icon :icon="add" />
      </ion-fab-button>
    </ion-fab>
    <!-- <ion-fab v-else-if="computedShowActions" 
      :class="{ filtered: (searchInput && searchInput.trim() !== '') || (searchAsyncInput && searchAsyncInput.trim() !== '') || (filters && filters.length > 0)}" 
        horizontal="end" vertical="bottom" slot="fixed" animated>
      <ion-fab-button>
        <ion-icon :icon="ellipsisVertical" />
      </ion-fab-button>
      <ion-fab-list side="top">
        <ion-fab-button @click="showSearch()">
          <ion-icon :icon="searchIcon" />
        </ion-fab-button>
        <ion-fab-button v-if="computedDataFilters && computedDataFilters.length > 0" @click="showFilters()">
          <ion-icon :icon="filterOutline"></ion-icon>
        </ion-fab-button>
        <ion-fab-button v-if="claims.add" @click="callRegister()">
          <ion-icon :icon="add" />
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab> -->

    <ion-modal :is-open="computedOpenFilter">
      <DataTableFilters
        ref="DataTableFilters"
        :filtersProps="computedDataFilters"
        :filtersMounted="filtersMounted"
        @cancelFilters="openFilter = false; this.toggleFiltering(({open: false, hasFilter: this.filters && this.filters.length > 0}))"
        v-on:change="updateSearch"
      />
    </ion-modal>
  </ion-content>
</template>

<script>
  import {
    IonCard,
    IonCardContent,
    IonModal,
    // IonList,
    IonCol,
    IonRow,
    IonGrid,
    IonIcon,
    IonLabel,
    IonSpinner,
    IonFabButton,
    IonFab,
    // IonFabList,
    IonContent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    alertController
  } from "@ionic/vue";
  import Refresher from "./Refresher.vue"
  import DataTableFilters from "./DataTableFilters.vue"
  import { add, trash, gift, ellipsisVertical, search as searchIcon, wifiOutline, filterOutline } from "ionicons/icons";
  import { createNamespacedHelpers, mapActions, mapState } from "vuex";
  import store from "../store";
  import { ref } from "vue";
  const { mapState: registersState, mapActions: registersActions } = createNamespacedHelpers("registers");
  const { mapState: authState } = createNamespacedHelpers("auth");
  export default {
    name: "DataTable",
    components: {
      IonCard,
      IonCardContent,
      // IonList,
      IonCol,
      IonRow,
      IonLabel,
      IonSpinner,
      IonGrid,
      IonIcon,
      IonFabButton,
      IonFab,
      // IonFabList,
      IonModal,
      IonContent,
      IonInfiniteScroll,
      IonInfiniteScrollContent,
      Refresher,
      DataTableFilters
    },
    props: {
      props: {
        type: Object,
        default: () => {}
      },
      myObserver: {},
      items: Array,
      headers: Array,
      opt: Object,
      collection: String,
      register: String,
      details: Array,
      claims: Object,
      blockedField: String,
      blockedFunction: Function,
      integration: Boolean,
      searchAsyncInput: String,
      searchAsyncLoading: Boolean,
      dataFilters: {
        type: Array,
        default: () => [],
      },
      inputsMaster: {
        type: Array,
        default: () => [],
      },
      customActions: Array,
    },
    data() {
      return {
        disableInfiniteScroll: false,
        openFilter: false,
        dialog: false,
        dialogImporter: false,
        dialogRemoveItem: false,
        selected: [],
        saveValid: true,
        importValid: true,
        selecteds: [],
        bundleActions: false,
        dialogBundleRemove: false,
        itemLoaded: {},
        itemComputed: {},
        itemToRemove: {},
        showPassword: false,
        method: "new",
        searchAutocomplete: null,
        loadingAutocomplete: false,
        querySelection: null,
        dataTableChips: 1,
        formChips: 4,
        vjsf: {},
        searchInput: "",
        algoliaHits: [],
        algoliaFilters: [],
        filters: [],
        filterItems: {},
        statusHeader: {},
        statusAltHeader: {},
        titleHeader: {},
        titleRightHeaders: [],
        subTitleHeader: {},
        allHeaders: [],
        filtersMounted: {},
        searchAsyncHits: [],
        // searchAsyncLoading: false
      };
    },
    computed: {
      ...registersState(["registers", "counters", "loading"]),
      ...mapState(["algolia", "searching", "offline", 'companySelected', 'filterHeader']),
      ...authState(["user"]),
      computedStatusAlt(){
        const status = this.headers.find((h) => h.value === "status2")
        try{
          if(status){
            status.list = typeof status.list == 'string' ? eval(status.list) || false : status.list
            if(typeof status.list == 'function'){
              return status.list({user: this.user})
            }
          }
        } catch (e){
          return false
        }
        return status?.list || false
      },
      computedShowActions() {
        return (this.computedDataFilters && this.computedDataFilters.length > 0) || this.claims.add
      },
      computedItems() {
        const items = 
          (this.searchInput && this.searchInput.trim() !== '') 
          ||
          (this.searchAsyncInput && this.searchAsyncInput.trim() !== '') 
          ||
          (this.filters && this.filters.length > 0)
          ? this.registers[`${this.register}Filtered`] || this.algoliaHits
          : this.opt.items || [];
        return items
      },
      registersCount() {
        return this.searchAsyncHits.length || this.algoliaHits.length || this.counters[this.collection];
      },
      // computedDataFilters() {
      //   return this.user.companies[this.companySelected.groupCompany].admin
      //     ? this.dataFilters.map(f => f.data || f)
      //     : this.dataFilters.filter(filter => filter.userRules?.some(ur => this.user?.rules?.indexOf(ur) >= 0)).map(f => f.data || f)
      // },
      computedOpenFilter() {
        return this.openFilter
      },
      computedHeaders() {
        return this.headers
      },
      computedDataFilters() {
        const filters = this.opt.allHeaders
        .filter(x => x.filterable)
        .concat(this.dataFilters.filter(x => !x.delete).map(f => f.data || f))
        .sort((a,b) => a.filterIndex-b.filterIndex);
        
        if (!this.user) return null

        if (this.user.superAdmin || this.user.companies[this.companySelected.groupCompany].admin) {
          return filters
        } else  {
          return filters.filter(filter => 
            filter.filterable && filter.filterable.userRules && filter.filterable.userRules.some(ur => this.userRules.some(uUR => uUR.id === ur)) || 
            filter.userRules && filter.userRules.some(ur => this.userRules.some(uUR => uUR.id === ur))
          )
        }
      },

      userRules() {
        if (this.user.superAdmin) {
          return this.computedUserRules
        } else if (!this.user.companies) {
          return []
        }
        return this.computedUserRules.filter(ur => 
          this.user.companies &&
          this.user.companies[this.companySelected.groupCompany] &&
          this.user.companies[this.companySelected.groupCompany]['rules'] && 
          this.user.companies[this.companySelected.groupCompany]['rules'].includes(ur.id)
        )
      },
      computedUserRules () {
        return this.registers['userRules']
      },
      headersMobile() {
        return this.headers.filter((h) => h.mobile);
      },
    },
    watch: {
      filterHeader: {
        handler: function ({open, hasFilter}) {
          this.openFilter = open
        },
        deep: true
      },
      searching: {
        handler: function (newValue) {
          if (!newValue.stats) {
            this.algoliaFilters = [];
          }
        },
      },
      selecteds: {
        handler: function (newValue) {
          this.bundleActions = newValue.length > 1;
        },
      },
      itemLoaded: {
        handler: function (newValue) {
          const inputs = this.opt.form.inputs;
          const jsoneditorValues = inputs
            .filter((x) => x.type == "jsoneditor")
            .map((x) => x.value);
          jsoneditorValues.forEach((el) => {
            if (!newValue[el]) return;
            this.itemComputed[el] = store.$_.cloneDeep(newValue[el]);
            const properties = Object.fromEntries(
              Object.entries(this.itemComputed[el].properties).sort(
                ([, a], [, b]) => a.order - b.order
              )
            );
            this.itemComputed[el].properties = properties;
          });
        },
        deep: true,
      },
    },
    methods: {
      ...mapActions(["dispatchAction", "toggleSearching", "dispatchSearchingAsync", 'toggleFiltering']),
      ...registersActions([
        'searchAlgolian',
        "save",
        "remove",
        "import",
        "nextObserver",
        "getDetails",
        "get",
        "removeBundle",
        "showToast"
      ]),

      onLongPressStart () {
        this.showToast({ message: 'long press', color: "success" })
      },
      
      async presentConfirmRemove(item) {
        let itemToRemove = item
        const alert = await alertController
          .create({
            header: 'Atenção!',
            message: 'Confirmar remoção do pedido?',
            buttons: [{
              text: 'Cancelar',
              role: 'cancel',  
            },
            {
              text: 'Confirmar',
              handler: (item) => {
                this.removeItem(itemToRemove)
              }
            }],
          });
        await alert.present();

        const { role } = await alert.onDidDismiss();
      },
      bonifyRegister(item){
        const path = store.$router.currentRoute.value.path;
        store.$router.push(path + `/bonificar/${item.id}`);
      },
      showItem(item) {
        const blocked = this.isBlocked({item})
        const path = store.$router.currentRoute.value.path;
        
        store.$router.push(`${path}/${(blocked) ? 'detalhes' : 'editar'}/${item.id}`);
      },
      initialize() {
        const inputs = this.opt.form.inputs;
        inputs.forEach((el, ix) => {
          this.$set(inputs[ix], "showPassword", false);
        });
      },
      updatePage(e) {
        this.nextObserver({ register: this.register }).then(()=>{
          e.target.complete()
        })
      },
      selectAll({ items, value, itemValue }) {
        this.$nextTick(() => {
          if (
            items &&
            this.itemLoaded[value] &&
            this.itemLoaded[value].length >= items.length
          ) {
            this.$set(this.itemLoaded, value, []);
          } else if (items) {
            this.$set(
              this.itemLoaded,
              value,
              itemValue ? items.map((x) => x[itemValue]).slice() : items.slice()
            );
          }
        });
      },
      querySelections(query, { collection, register, filters, orderBy }) {
        clearTimeout(this.querySelection);
        this.querySelection = setTimeout(async () => {
          if (!query || !collection || !register || !orderBy) return;
          this.loadingAutocomplete = true;
          this.get({ collection, register, orderBy, filters, query }).then(
            () => (this.loadingAutocomplete = false)
          );
        }, 500);
      },
      proccessItem({ item, head, copy = false }) {
        let ret = store.$_.cloneDeep(item);
        if (!ret) return;
        if (
          ret._highlightResult &&
          ret._highlightResult[head.value] &&
          ret._highlightResult[head.value].matchedWords &&
          ret._highlightResult[head.value].matchedWords.length > 0
        )
          ret = ret._highlightResult;

        /* NESTED */

        const pathItem = head.value.split(".");
        const lenItem = pathItem.length;
        if (lenItem == 1) {
          ret = ret[pathItem];
        } else {
          for (let ix = 0; ix < pathItem.length; ix++) {
            const el = pathItem[ix];
            if (ret && typeof ret[el] != "undefined") {
              ret = ret[el];
            } else {
              ret = head.checkbox ? false : "";
              break;
            }
          }
        }

        /* ASSIST */

        const detail = head.detail;
        if (detail && ret) {
          const pathAssist = detail.split(".");
          const lenAssist = pathAssist.length;
          if (Array.isArray(ret)) {
            ret.forEach((el, ix) => {
              let retEl = this.registers[pathAssist[0]]
                ? this.registers[pathAssist[0]].find((x) => x.id === el)
                : null;
              if (retEl) {
                for (let i = 1; i < lenAssist; i++) {
                  const el2 = pathAssist[i];
                  retEl = retEl ? retEl[el2] : "";
                }
                ret[ix] = retEl;
              }
            });
          } else {
            let retEl = this.registers[pathAssist[0]]
              ? this.registers[pathAssist[0]].find((x) => x.id === ret)
              : null;
            for (let i = 1; i < lenAssist; i++) {
              const el = pathAssist[i];
              retEl = retEl ? retEl[el] : "";
            }
            ret = retEl;
          }
        }

        /* FORMATS */

        if (!ret) return;
        if (ret && ret.value) ret = ret.value;
        if (head.slice && !copy) {
          ret = ret.slice(head.slice);
        }
        if (head.upper) {
          ret = ret.toUpperCase();
        }
        if (head.lower) {
          ret = ret.toLowerCase();
        }
        if (head.trim) {
          ret = ret.trim();
        }

        /* FORMAT DATES */
        if (head.date || head.dateHour || head.dateYear || head.datePlusWeek) {
          if (Object.prototype.hasOwnProperty.call(ret, "toDate"))
            ret = ret.toDate();
          else if (ret.seconds && ret.nanoseconds)
            ret = new store.$db.Timestamp(ret.seconds, ret.nanoseconds).toDate(); // Retorno via Algolia não contem metodo toDate
          else if (ret._seconds && ret._nanoseconds)
            ret = new store.$db.Timestamp(ret._seconds, ret._nanoseconds).toDate(); // Retorno via Algolia não contem metodo toDate
        }
        if (head.date) {
          ret = store.$moment(ret).format("DD/MM/YYYY");
        }
        if (head.dateHour) {
          ret = store.$moment(ret).format("DD/MM/YYYY - HH:mm:ss");
        }
        if (head.dateYear) {
          ret = store.$moment(ret).format("YYYY");
        }
        if (head.datePlusWeek) {
          ret = store.$moment(ret).format("DD/MM/YYYY, dddd");
        }
        
        if (head.money) {
          if (typeof ret == 'string') ret = parseFloat(ret)
          ret =
            "R$ " +
            ret.toLocaleString("pt-BR", {
              minimumFractionDigits: head.precisionText || 2,
              maximumFractionDigits: head.precisionText || 2,
            });
        }

        // if (options.slice) { obj = (obj) ? obj.slice(options.slice) : '' }
        // if (options.multiplier) { obj = (obj) ? obj * options.multiplier : '' }

        return ret;
      },
      proccessParams({ item, params }) {
        const ret = {};
        for (const key in params) {
          if (Object.prototype.hasOwnProperty.call(params, key)) {
            const el = params[key];
            const pathItem = el.split(".");
            const lenItem = pathItem.length;
            if (lenItem == 1) {
              ret[key] = pathItem[0];
            } else {
              for (let ix = 1; ix < pathItem.length; ix++) {
                const el2 = pathItem[ix];
                if (typeof item[el2] != "undefined") {
                  ret[key] = item[el2];
                } else {
                  ret[key] = "";
                  break;
                }
              }
            }
          }
        }
        return ret;
      },
      newItem() {
        this.itemLoaded = {};
        this.method = "new";
        const inputs = this.opt.form.inputs;
        inputs.forEach((el) => {
          if (el.default) {
            this.itemLoaded[el.value] = el.default;
          }
        });
      },
      importer() {
        this.itemLoaded = {};
        this.method = "import";
      },
      closeDialog() {
        this.dialog = false;
      },
      closeDialogImporter() {
        this.dialogImporter = false;
      },
      clipboardCopy: function (e) {
        this.$toast.success("Copiado");
      },
      clipboardError: function (e) {
        this.$toast.error("Falha ao copiar");
      },
      toggleCk({ item, head }) {
        const pathItem = head.value.split(".");
        const lenItem = pathItem.length;
        let schema = item;
        for (let i = 0; i < lenItem - 1; i++) {
          const el = pathItem[i];
          if (!schema[el]) schema[el] = {};
          schema = schema[el];
        }
        schema[pathItem[lenItem - 1]] = !schema[pathItem[lenItem - 1]];

        this.saveItem(item);
      },
      removeChip({ value, item, itemValue }) {
        const ix = this.itemLoaded[value].findIndex((x) => x == item[itemValue]);
        if (ix > -1) this.itemLoaded[value].splice(ix, 1);
      },
      editItem(item) {
        // Details
        if (this.details) {
          this.details.forEach((detail) => {
            this.getDetails({
              item: store.$_.cloneDeep(item),
              detail: store.$_.cloneDeep(detail),
              endSlice: this.formChips + 1,
            });
          });
        }

        // Order Json
        const inputs = this.opt.form.inputs;
        const jsoneditorValues = inputs
          .filter((x) => x.type == "jsoneditor")
          .map((x) => x.value);
        jsoneditorValues.forEach((el) => {
          if (!item[el]) return;
          const properties = Object.fromEntries(
            Object.entries(item[el].properties).sort(
              ([, a], [, b]) => a.order - b.order
            )
          );
          item[el].properties = properties;
        });

        // Load Item
        this.itemLoaded = store.$_.cloneDeep(item);
        this.method = "edit";
        this.dialog = true;
      },
      saveItem(item) {
        if (this.$refs.save && !this.$refs.save.validate()) return;

        // Dispatch Before
        if (this.opt.dispatch) {
          this.opt.dispatch
            .filter((x) => x.when == "before" && x.method == this.method)
            .forEach((el) => {
              if (!el.switch || item[el.switch]) {
                this.dispatchAction({
                  action: el.action,
                  params: this.proccessParams({ params: el.params, item }),
                });
              }
            });
        }

        this.save({ collection: this.collection, item, integration: true })
          .then(() => {
            // Dispatch After
            if (this.opt.dispatch) {
              this.opt.dispatch
                .filter((x) => x.when == "after" && x.method == this.method)
                .forEach((el) => {
                  if (!el.switch || item[el.switch]) {
                    this.dispatchAction({
                      action: el.action,
                      params: this.proccessParams({ params: el.params, item }),
                    });
                  }
                });
            }

            this.closeDialog();
          })
          .catch((error) => console.error(error));
      },
      confirmRemove(item) {
        this.itemToRemove = store.$_.cloneDeep(item);
        this.dialogRemoveItem = true;
      },
      removeItem(item) {
        this.remove({
          collection: this.collection,
          integration: this.integration,
          item,
        });
        this.dialogRemoveItem = false;
      },
      removeItens() {
        this.removeBundle({
          collection: this.collection,
          integration: this.integration,
          itens: this.selecteds,
        })
          .then(() => {
            this.selecteds = [];
            this.dialogBundleRemove = false;
          })
          .catch((error) => {});
      },
      closeDialogRemoveItem() {
        this.itemToRemove = store.$_.cloneDeep({});
        this.dialogRemoveItem = false;
      },
      sendImport(item) {
        if (this.$refs.import && !this.$refs.import.validate()) return;

        this.import({ collection: this.collection, item })
          .then(() => this.closeDialogImporter())
          .catch((error) => {});
      },

      updateSearch({filters, filtersMounted}) {
        this.filters = filters
        this.filtersMounted = filtersMounted
        
        if (this.props.mobileV2) {
          this.dispatchSearchingAsync({query: this.searchAsyncInput, filters: this.filters})
        } else {
          // const input = (this.externalRequest && this.externalRequest.query) ? 'externalSearchInput' : 'algoliaSearchInput'
          this.search(this.searchAlgolian({
            index: this.collection, 
            query: this.searchInput, 
            facetFilters: this.filters, 
            attributesToHighlight: this.headers
              .filter((h) => h.mobile)
              .map((h) => h.value)
          }))
          // this.$refs[input].search(this.searchInput, this.filters)
        }
        
        this.openFilter = false
        this.toggleFiltering({open: false, hasFilter: filters && filters.length > 0})
      },
      async search(req) {
        try {
          const result = await req;
          const { hits, params, query } = result
          this.searchInput = query
          this.algoliaHits = hits
        } catch (err) {
          console.error(err);
          this.algoliaHits = [];
        }
      },
   
      async searchFilter(req, filter) {
        try {
          const { hits } = await req;
          this.filterItems[filter.algoliaIndex].splice(0);
          if (hits) this.filterItems[filter.algoliaIndex].push(...hits);
        } catch (err) {
          console.error(err);
          this.filterItems[filter.algoliaIndex].splice(0);
        }
      },
      searchAlgolia(algoliaFilters) {
        this.algoliaFilters = algoliaFilters;
        this.$refs.algoliaSearchInput.search(this.searchInput, algoliaFilters);
      },
      setAlgoliaFilters() {
        this.algoliaFilters = this.dataFilters
          .filter((filter) => filter.model)
          .map((filter) => [
            `${filter.filterKey}:${filter.model[filter.itemKey || filter.filterItemKey]}`,
          ]);

        // realiza a busca
        this.$refs.algoliaSearchInput.search(
          this.searchInput,
          this.algoliaFilters
        );
      },
      callRegister() {
        const path = store.$router.currentRoute.value.path;
        store.$router.push(path + "/cadastrar");
      },
      showFilters () {
        this.openFilter = true;
      },
      showSearch() {
        this.toggleSearching({
          stats: true,
          index: this.collection,
          handler: this.search,
          filters: this.algoliaFilters,
          attributesToHighlight: this.headers
            .filter((h) => h.mobile)
            .map((h) => h.value),
        });
      },
      toggleOffline(item) {
        item.offline = !item.offline
        this.saveItem(item);
      },
      isBlocked({ item }) {
        if (this.blockedField) return item[this.blockedField];

        if (this.blockedFunction) return this.blockedFunction({ item });

        return false;
      }
    },
    setup() {
      const isOpenRef = ref(false);
      const buttons = [{
        text: 'Cancelar',
        role: 'cancel',
      },
      {
        text: 'Confirmar',
        handler: () => {
          this.removeItem(this.itemToRemove)
        }
      }
      ];
      const setOpen = (value) => {
        isOpenRef.value = value;
      };
      return { add, trash, gift, ellipsisVertical, searchIcon, isOpenRef, setOpen, wifiOutline, buttons, filterOutline };
    },
    created() {
      // fields on headers
      this.titleHeader = this.headersMobile.find(
        (hm) => hm.mobile.type === "title"
      );
      this.titleRightHeaders = this.headersMobile
        .filter((hm) => hm.mobile.type === "titleRight")
        .sort((h1, h2) => {
          if (h1.mobile.verticalPosition > h2.mobile.verticalPosition) return 1;
          if (h1.mobile.verticalPosition < h2.mobile.verticalPosition) return -1;
          return 0;
        });
      this.subTitleHeader = this.headersMobile.find(
        (hm) => hm.mobile.type === "subTitle"
      );
      this.allHeaders = this.headersMobile
        .filter((hm) => hm.mobile.type === "all")
        .sort((h1, h2) => {
          if (h1.mobile.horizontalPosition > h2.mobile.horizontalPosition)
            return 1;
          if (h1.mobile.horizontalPosition < h2.mobile.horizontalPosition)
            return -1;
          return 0;
        });
      this.statusHeader = this.headers.find((h) => h.value === "status" || h.mobile?.type === 'statusHeader');
      this.statusAltHeader = this.headers.find((h) => h.value === "status2")
      this.statusHeaderDesc = this.headers.find((h) => h.mobile?.type === 'statusHeaderDesc');

      // dataFilters
      this.dataFilters.forEach(async (filter) => {
        if (filter.source == "collection") {
          /** @TODO */
          const algoliaClient = algoliasearch(
            this.algolia.appId,
            this.algolia.searchApiKey
          );
          const algoliaIndex = algoliaClient.initIndex(filter.collectionName);
          try {
            filter.loading = true;
            const response = await algoliaIndex.search();

            if (response && response.hits) {
              filter.values = response.hits.map(
                (hit) => hit[filter.collectionField]
              );
            } else {
              console.warn("Error in algolia search on filter " + filter.name);
              filter.values = [];
            }
          } catch (err) {
            console.error(err);
          } finally {
            filter.loading = false;
          }
        } else if (filter.source == "algolia") {
          // prop items
          this.filterItems[filter.algoliaIndex] = [];

          // prop item-text
          filter.itemText = (item) => {
            if (!filter.fieldsToShow) return "id";

            let str = item[filter.fieldsToShow[0]];
            filter.fieldsToShow.slice(1).forEach((field) => {
              str = str + " - " + item[field];
            });

            return str;
          };

          // prop no-data-text
          filter.noDataTextDefault = "Digite algo para pesquisar";
          filter.noDataText = filter.noDataTextDefault;
        }
      });

      if (this.props.mobileV2) {
        // MOVIDO PARA O LIST.VUE (initSearch)
      } else {
        this.toggleSearching({
          stats: true,
          index: this.collection,
          handler: this.search,
          filters: this.algoliaFilters,
          attributesToHighlight: this.headers
            .filter((h) => h.mobile)
            .map((h) => h.value)
        });
      }
    },
  };
</script>

<style scoped>
  .card-items {
    margin: .2em;
  }
  .wrap-text {
    padding-top: 2px;
    padding-bottom: 2px;
    display: block;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ion-col {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content-datatable {
    padding: 0px!important;
    margin: 0px!important;
  }

  .list-datatable {
    width: '100%'; 
    background-color: var(--ion-background-color);
    /* padding: 3.75em 0em 0em 0em; */
    margin: 0px!important;
  }

  /* Colors */
  .error { background-color: #e64a19; }
  .offline{ background-color: rgb(30, 36, 36); }
  
  .white { background-color: white; }
  .black { background-color: black; }
  .transparent { background-color: #FFFFFF00; }
  
  .red { background-color: #F44336; }
  .red.lighten-5 { background-color: #FFEBEE; }
  .red.lighten-4 { background-color: #FFCDD2; }
  .red.lighten-3 { background-color: #EF9A9A; }
  .red.lighten-2 { background-color: #E57373; }
  .red.lighten-1 { background-color: #EF5350; }
  .red.darken-1 { background-color: #E53935; }
  .red.darken-2 { background-color: #D32F2F; }
  .red.darken-3 { background-color: #C62828; }
  .red.darken-4 { background-color: #B71C1C; }
  .red.accent-1 { background-color: #FF8A80; }
  .red.accent-2 { background-color: #FF5252; }
  .red.accent-3 { background-color: #FF1744; }
  .red.accent-4 { background-color: #D50000; }

  .pink { background-color: #E91E63; }
  .pink.lighten-5 { background-color: #FCE4EC; }
  .pink.lighten-4 { background-color: #F8BBD0; }
  .pink.lighten-3 { background-color: #F48FB1; }
  .pink.lighten-2 { background-color: #F06292; }
  .pink.lighten-1 { background-color: #EC407A; }
  .pink.darken-1 { background-color: #D81B60; }
  .pink.darken-2 { background-color: #C2185B; }
  .pink.darken-3 { background-color: #AD1457; }
  .pink.darken-4 { background-color: #880E4F; }
  .pink.accent-1 { background-color: #FF80AB; }
  .pink.accent-2 { background-color: #FF4081; }
  .pink.accent-3 { background-color: #F50057; }
  .pink.accent-4 { background-color: #C51162; }
  
  .purple { background-color: #9C27B0; }
  .purple.lighten-5 { background-color: #F3E5F5; }
  .purple.lighten-4 { background-color: #E1BEE7; }
  .purple.lighten-3 { background-color: #CE93D8; }
  .purple.lighten-2 { background-color: #BA68C8; }
  .purple.lighten-1 { background-color: #AB47BC; }
  .purple.darken-1 { background-color: #8E24AA; }
  .purple.darken-2 { background-color: #7B1FA2; }
  .purple.darken-3 { background-color: #6A1B9A; }
  .purple.darken-4 { background-color: #4A148C; }
  .purple.accent-1 { background-color: #EA80FC; }
  .purple.accent-2 { background-color: #E040FB; }
  .purple.accent-3 { background-color: #D500F9; }
  .purple.accent-4 { background-color: #AA00FF; }
  
  .deep-purple { background-color: #673AB7; }
  .deep-purple.lighten-5 { background-color: #EDE7F6; }
  .deep-purple.lighten-4 { background-color: #D1C4E9; }
  .deep-purple.lighten-3 { background-color: #B39DDB; }
  .deep-purple.lighten-2 { background-color: #9575CD; }
  .deep-purple.lighten-1 { background-color: #7E57C2; }
  .deep-purple.darken-1 { background-color: #5E35B1; }
  .deep-purple.darken-2 { background-color: #512DA8; }
  .deep-purple.darken-3 { background-color: #4527A0; }
  .deep-purple.darken-4 { background-color: #311B92; }
  .deep-purple.accent-1 { background-color: #B388FF; }
  .deep-purple.accent-2 { background-color: #7C4DFF; }
  .deep-purple.accent-3 { background-color: #651FFF; }
  .deep-purple.accent-4 { background-color: #6200EA; }

  .indigo { background-color: #3F51B5; }
  .indigo.lighten-5 { background-color: #E8EAF6; }
  .indigo.lighten-4 { background-color: #C5CAE9; }
  .indigo.lighten-3 { background-color: #9FA8DA; }
  .indigo.lighten-2 { background-color: #7986CB; }
  .indigo.lighten-1 { background-color: #5C6BC0; }
  .indigo.darken-1 { background-color: #3949AB; }
  .indigo.darken-2 { background-color: #303F9F; }
  .indigo.darken-3 { background-color: #283593; }
  .indigo.darken-4 { background-color: #1A237E; }
  .indigo.accent-1 { background-color: #8C9EFF; }
  .indigo.accent-2 { background-color: #536DFE; }
  .indigo.accent-3 { background-color: #3D5AFE; }
  .indigo.accent-4 { background-color: #304FFE; }

  .blue { background-color: #2196F3; }
  .blue.lighten-5 { background-color: #E3F2FD; }
  .blue.lighten-4 { background-color: #BBDEFB; }
  .blue.lighten-3 { background-color: #90CAF9; }
  .blue.lighten-2 { background-color: #64B5F6; }
  .blue.lighten-1 { background-color: #42A5F5; }
  .blue.darken-1 { background-color: #1E88E5; }
  .blue.darken-2 { background-color: #1976D2; }
  .blue.darken-3 { background-color: #1565C0; }
  .blue.darken-4 { background-color: #0D47A1; }
  .blue.accent-1 { background-color: #82B1FF; }
  .blue.accent-2 { background-color: #448AFF; }
  .blue.accent-3 { background-color: #2979FF; }
  .blue.accent-4 { background-color: #2962FF; }

  .light-blue { background-color: #03A9F4; }
  .light-blue.lighten-5 { background-color: #E1F5FE; }
  .light-blue.lighten-4 { background-color: #B3E5FC; }
  .light-blue.lighten-3 { background-color: #81D4FA; }
  .light-blue.lighten-2 { background-color: #4FC3F7; }
  .light-blue.lighten-1 { background-color: #29B6F6; }
  .light-blue.darken-1 { background-color: #039BE5; }
  .light-blue.darken-2 { background-color: #0288D1; }
  .light-blue.darken-3 { background-color: #0277BD; }
  .light-blue.darken-4 { background-color: #01579B; }
  .light-blue.accent-1 { background-color: #80D8FF; }
  .light-blue.accent-2 { background-color: #40C4FF; }
  .light-blue.accent-3 { background-color: #00B0FF; }
  .light-blue.accent-4 { background-color: #0091EA; }

  .cyan { background-color: #00BCD4; }
  .cyan.lighten-5 { background-color: #E0F7FA; }
  .cyan.lighten-4 { background-color: #B2EBF2; }
  .cyan.lighten-3 { background-color: #80DEEA; }
  .cyan.lighten-2 { background-color: #4DD0E1; }
  .cyan.lighten-1 { background-color: #26C6DA; }
  .cyan.darken-1 { background-color: #00ACC1; }
  .cyan.darken-2 { background-color: #0097A7; }
  .cyan.darken-3 { background-color: #00838F; }
  .cyan.darken-4 { background-color: #006064; }
  .cyan.accent-1 { background-color: #84FFFF; }
  .cyan.accent-2 { background-color: #18FFFF; }
  .cyan.accent-3 { background-color: #00E5FF; }
  .cyan.accent-4 { background-color: #00B8D4; }

  .teal { background-color: #009688; }
  .teal.lighten-5 { background-color: #E0F2F1; }
  .teal.lighten-4 { background-color: #B2DFDB; }
  .teal.lighten-3 { background-color: #80CBC4; }
  .teal.lighten-2 { background-color: #4DB6AC; }
  .teal.lighten-1 { background-color: #26A69A; }
  .teal.darken-1 { background-color: #00897B; }
  .teal.darken-2 { background-color: #00796B; }
  .teal.darken-3 { background-color: #00695C; }
  .teal.darken-4 { background-color: #004D40; }
  .teal.accent-1 { background-color: #A7FFEB; }
  .teal.accent-2 { background-color: #64FFDA; }
  .teal.accent-3 { background-color: #1DE9B6; }
  .teal.accent-4 { background-color: #00BFA5; }

  .green { background-color: #4CAF50; color: #4CAF50; }
  .green.lighten-5 { background-color: #E8F5E9; }
  .green.lighten-4 { background-color: #C8E6C9; }
  .green.lighten-3 { background-color: #A5D6A7; }
  .green.lighten-2 { background-color: #81C784; }
  .green.lighten-1 { background-color: #66BB6A; }
  .green.darken-1 { background-color: #43A047; }
  .green.darken-2 { background-color: #388E3C; }
  .green.darken-3 { background-color: #2E7D32; }
  .green.darken-4 { background-color: #1B5E20; }
  .green.accent-1 { background-color: #B9F6CA; }
  .green.accent-2 { background-color: #69F0AE; }
  .green.accent-3 { background-color: #00E676; }
  .green.accent-4 { background-color: #00C853; }
  
  .light-green  { background-color: #8BC34A; }
  .light-green.lighten-5 { background-color: #F1F8E9; }
  .light-green.lighten-4 { background-color: #DCEDC8; }
  .light-green.lighten-3 { background-color: #C5E1A5; }
  .light-green.lighten-2 { background-color: #AED581; }
  .light-green.lighten-1 { background-color: #9CCC65; }
  .light-green.darken-1 { background-color: #7CB342; }
  .light-green.darken-2 { background-color: #689F38; }
  .light-green.darken-3 { background-color: #558B2F; }
  .light-green.darken-4 { background-color: #33691E; }
  .light-green.accent-1 { background-color: #CCFF90; }
  .light-green.accent-2 { background-color: #B2FF59; }
  .light-green.accent-3 { background-color: #76FF03; }
  .light-green.accent-4 { background-color: #64DD17; }

  .lime { background-color: #CDDC39; }
  .lime.lighten-5 { background-color: #F9FBE7; }
  .lime.lighten-4 { background-color: #F0F4C3; }
  .lime.lighten-3 { background-color: #E6EE9C; }
  .lime.lighten-2 { background-color: #DCE775; }
  .lime.lighten-1 { background-color: #D4E157; }
  .lime.darken-1 { background-color: #C0CA33; }
  .lime.darken-2 { background-color: #AFB42B; }
  .lime.darken-3 { background-color: #9E9D24; }
  .lime.darken-4 { background-color: #827717; }
  .lime.accent-1 { background-color: #F4FF81; }
  .lime.accent-2 { background-color: #EEFF41; }
  .lime.accent-3 { background-color: #C6FF00; }
  .lime.accent-4 { background-color: #AEEA00; }
  
  .yellow { background-color: #FFEB3B; }
  .yellow.lighten-5 { background-color: #FFFDE7; }
  .yellow.lighten-4 { background-color: #FFF9C4; }
  .yellow.lighten-3 { background-color: #FFF59D; }
  .yellow.lighten-2 { background-color: #FFF176; }
  .yellow.lighten-1 { background-color: #FFEE58; }
  .yellow.darken-1 { background-color: #FDD835; }
  .yellow.darken-2 { background-color: #FBC02D; }
  .yellow.darken-3 { background-color: #F9A825; }
  .yellow.darken-4 { background-color: #F57F17; }
  .yellow.accent-1 { background-color: #FFFF8D; }
  .yellow.accent-2 { background-color: #FFFF00; }
  .yellow.accent-3 { background-color: #FFEA00; }
  .yellow.accent-4 { background-color: #FFD600; }

  .amber { background-color: #FFC107; }
  .amber.lighten-5 { background-color: #FFF8E1; }
  .amber.lighten-4 { background-color: #FFECB3; }
  .amber.lighten-3 { background-color: #FFE082; }
  .amber.lighten-2 { background-color: #FFD54F; }
  .amber.lighten-1 { background-color: #FFCA28; }
  .amber.darken-1 { background-color: #FFB300; }
  .amber.darken-2 { background-color: #FFA000; }
  .amber.darken-3 { background-color: #FF8F00; }
  .amber.darken-4 { background-color: #FF6F00; }
  .amber.accent-1 { background-color: #FFE57F; }
  .amber.accent-2 { background-color: #FFD740; }
  .amber.accent-3 { background-color: #FFC400; }
  .amber.accent-4 { background-color: #FFAB00; }

  .orange { background-color: #FF9800; }
  .orange.lighten-5 { background-color: #FFF3E0; }
  .orange.lighten-4 { background-color: #FFE0B2; }
  .orange.lighten-3 { background-color: #FFCC80; }
  .orange.lighten-2 { background-color: #FFB74D; }
  .orange.lighten-1 { background-color: #FFA726; }
  .orange.darken-1 { background-color: #FB8C00; }
  .orange.darken-2 { background-color: #F57C00; }
  .orange.darken-3 { background-color: #EF6C00; }
  .orange.darken-4 { background-color: #E65100; }
  .orange.accent-1 { background-color: #FFD180; }
  .orange.accent-2 { background-color: #FFAB40; }
  .orange.accent-3 { background-color: #FF9100; }
  .orange.accent-4 { background-color: #FF6D00; }

  .deep-orange { background-color: #FF5722; }
  .deep-orange.lighten-5 { background-color: #FBE9E7; }
  .deep-orange.lighten-4 { background-color: #FFCCBC; }
  .deep-orange.lighten-3 { background-color: #FFAB91; }
  .deep-orange.lighten-2 { background-color: #FF8A65; }
  .deep-orange.lighten-1 { background-color: #FF7043; }
  .deep-orange.darken-1 { background-color: #F4511E; }
  .deep-orange.darken-2 { background-color: #E64A19; }
  .deep-orange.darken-3 { background-color: #D84315; }
  .deep-orange.darken-4 { background-color: #BF360C; }
  .deep-orange.accent-1 { background-color: #FF9E80; }
  .deep-orange.accent-2 { background-color: #FF6E40; }
  .deep-orange.accent-3 { background-color: #FF3D00; }
  .deep-orange.accent-4 { background-color: #DD2C00; }

  .brown { background-color: #795548; }
  .brown.lighten-5 { background-color: #EFEBE9; }
  .brown.lighten-4 { background-color: #D7CCC8; }
  .brown.lighten-3 { background-color: #BCAAA4; }
  .brown.lighten-2 { background-color: #A1887F; }
  .brown.lighten-1 { background-color: #8D6E63; }
  .brown.darken-1 { background-color: #6D4C41; }
  .brown.darken-2 { background-color: #5D4037; }
  .brown.darken-3 { background-color: #4E342E; }
  .brown.darken-4 { background-color: #3E2723; }
  
  .blue-grey { background-color: #607D8B; }
  .blue-grey.lighten-5 { background-color: #ECEFF1; }
  .blue-grey.lighten-4 { background-color: #CFD8DC; }
  .blue-grey.lighten-3 { background-color: #B0BEC5; }
  .blue-grey.lighten-2 { background-color: #90A4AE; }
  .blue-grey.lighten-1 { background-color: #78909C; }
  .blue-grey.darken-1 { background-color: #546E7A; }
  .blue-grey.darken-2 { background-color: #455A64; }
  .blue-grey.darken-3 { background-color: #37474F; }
  .blue-grey.darken-4 { background-color: #263238; }

  .grey { background-color: #9E9E9E; }
  .grey.lighten-5 { background-color: #FAFAFA; }
  .grey.lighten-4 { background-color: #F5F5F5; }
  .grey.lighten-3 { background-color: #EEEEEE; }
  .grey.lighten-2 { background-color: #E0E0E0; }
  .grey.lighten-1 { background-color: #BDBDBD; }
  .grey.darken-1 { background-color: #757575; }
  .grey.darken-2 { background-color: #616161; }
  .grey.darken-3 { background-color: #424242; }
  .grey.darken-4 { background-color: #212121; }
  
  /* Text Colors */
  
  .text--error { color: #e64a19; }
  .text--offline{ color: rgb(30, 36, 36); }
  
  .text--white { color: white; }
  .text--black { color: black; }

  .text--red { color: #F44336; }
  .text--red.lighten-5 { color: #FFEBEE; }
  .text--red.lighten-4 { color: #FFCDD2; }
  .text--red.lighten-3 { color: #EF9A9A; }
  .text--red.lighten-2 { color: #E57373; }
  .text--red.lighten-1 { color: #EF5350; }
  .text--red.darken-1 { color: #E53935; }
  .text--red.darken-2 { color: #D32F2F; }
  .text--red.darken-3 { color: #C62828; }
  .text--red.darken-4 { color: #B71C1C; }
  .text--red.accent-1 { color: #FF8A80; }
  .text--red.accent-2 { color: #FF5252; }
  .text--red.accent-3 { color: #FF1744; }
  .text--red.accent-4 { color: #D50000; }

  .text--pink { color: #E91E63; }
  .text--pink.lighten-5 { color: #FCE4EC; }
  .text--pink.lighten-4 { color: #F8BBD0; }
  .text--pink.lighten-3 { color: #F48FB1; }
  .text--pink.lighten-2 { color: #F06292; }
  .text--pink.lighten-1 { color: #EC407A; }
  .text--pink.darken-1 { color: #D81B60; }
  .text--pink.darken-2 { color: #C2185B; }
  .text--pink.darken-3 { color: #AD1457; }
  .text--pink.darken-4 { color: #880E4F; }
  .text--pink.accent-1 { color: #FF80AB; }
  .text--pink.accent-2 { color: #FF4081; }
  .text--pink.accent-3 { color: #F50057; }
  .text--pink.accent-4 { color: #C51162; }
  
  .text--purple { color: #9C27B0; }
  .text--purple.lighten-5 { color: #F3E5F5; }
  .text--purple.lighten-4 { color: #E1BEE7; }
  .text--purple.lighten-3 { color: #CE93D8; }
  .text--purple.lighten-2 { color: #BA68C8; }
  .text--purple.lighten-1 { color: #AB47BC; }
  .text--purple.darken-1 { color: #8E24AA; }
  .text--purple.darken-2 { color: #7B1FA2; }
  .text--purple.darken-3 { color: #6A1B9A; }
  .text--purple.darken-4 { color: #4A148C; }
  .text--purple.accent-1 { color: #EA80FC; }
  .text--purple.accent-2 { color: #E040FB; }
  .text--purple.accent-3 { color: #D500F9; }
  .text--purple.accent-4 { color: #AA00FF; }
  
  .text--deep-purple { color: #673AB7; }
  .text--deep-purple.lighten-5 { color: #EDE7F6; }
  .text--deep-purple.lighten-4 { color: #D1C4E9; }
  .text--deep-purple.lighten-3 { color: #B39DDB; }
  .text--deep-purple.lighten-2 { color: #9575CD; }
  .text--deep-purple.lighten-1 { color: #7E57C2; }
  .text--deep-purple.darken-1 { color: #5E35B1; }
  .text--deep-purple.darken-2 { color: #512DA8; }
  .text--deep-purple.darken-3 { color: #4527A0; }
  .text--deep-purple.darken-4 { color: #311B92; }
  .text--deep-purple.accent-1 { color: #B388FF; }
  .text--deep-purple.accent-2 { color: #7C4DFF; }
  .text--deep-purple.accent-3 { color: #651FFF; }
  .text--deep-purple.accent-4 { color: #6200EA; }

  .text--indigo { color: #3F51B5; }
  .text--indigo.lighten-5 { color: #E8EAF6; }
  .text--indigo.lighten-4 { color: #C5CAE9; }
  .text--indigo.lighten-3 { color: #9FA8DA; }
  .text--indigo.lighten-2 { color: #7986CB; }
  .text--indigo.lighten-1 { color: #5C6BC0; }
  .text--indigo.darken-1 { color: #3949AB; }
  .text--indigo.darken-2 { color: #303F9F; }
  .text--indigo.darken-3 { color: #283593; }
  .text--indigo.darken-4 { color: #1A237E; }
  .text--indigo.accent-1 { color: #8C9EFF; }
  .text--indigo.accent-2 { color: #536DFE; }
  .text--indigo.accent-3 { color: #3D5AFE; }
  .text--indigo.accent-4 { color: #304FFE; }

  .text--blue { color: #2196F3; }
  .text--blue.lighten-5 { color: #E3F2FD; }
  .text--blue.lighten-4 { color: #BBDEFB; }
  .text--blue.lighten-3 { color: #90CAF9; }
  .text--blue.lighten-2 { color: #64B5F6; }
  .text--blue.lighten-1 { color: #42A5F5; }
  .text--blue.darken-1 { color: #1E88E5; }
  .text--blue.darken-2 { color: #1976D2; }
  .text--blue.darken-3 { color: #1565C0; }
  .text--blue.darken-4 { color: #0D47A1; }
  .text--blue.accent-1 { color: #82B1FF; }
  .text--blue.accent-2 { color: #448AFF; }
  .text--blue.accent-3 { color: #2979FF; }
  .text--blue.accent-4 { color: #2962FF; }

  .text--light-blue { color: #03A9F4; }
  .text--light-blue.lighten-5 { color: #E1F5FE; }
  .text--light-blue.lighten-4 { color: #B3E5FC; }
  .text--light-blue.lighten-3 { color: #81D4FA; }
  .text--light-blue.lighten-2 { color: #4FC3F7; }
  .text--light-blue.lighten-1 { color: #29B6F6; }
  .text--light-blue.darken-1 { color: #039BE5; }
  .text--light-blue.darken-2 { color: #0288D1; }
  .text--light-blue.darken-3 { color: #0277BD; }
  .text--light-blue.darken-4 { color: #01579B; }
  .text--light-blue.accent-1 { color: #80D8FF; }
  .text--light-blue.accent-2 { color: #40C4FF; }
  .text--light-blue.accent-3 { color: #00B0FF; }
  .text--light-blue.accent-4 { color: #0091EA; }

  .text--cyan { color: #00BCD4; }
  .text--cyan.lighten-5 { color: #E0F7FA; }
  .text--cyan.lighten-4 { color: #B2EBF2; }
  .text--cyan.lighten-3 { color: #80DEEA; }
  .text--cyan.lighten-2 { color: #4DD0E1; }
  .text--cyan.lighten-1 { color: #26C6DA; }
  .text--cyan.darken-1 { color: #00ACC1; }
  .text--cyan.darken-2 { color: #0097A7; }
  .text--cyan.darken-3 { color: #00838F; }
  .text--cyan.darken-4 { color: #006064; }
  .text--cyan.accent-1 { color: #84FFFF; }
  .text--cyan.accent-2 { color: #18FFFF; }
  .text--cyan.accent-3 { color: #00E5FF; }
  .text--cyan.accent-4 { color: #00B8D4; }

  .text--teal { color: #009688; }
  .text--teal.lighten-5 { color: #E0F2F1; }
  .text--teal.lighten-4 { color: #B2DFDB; }
  .text--teal.lighten-3 { color: #80CBC4; }
  .text--teal.lighten-2 { color: #4DB6AC; }
  .text--teal.lighten-1 { color: #26A69A; }
  .text--teal.darken-1 { color: #00897B; }
  .text--teal.darken-2 { color: #00796B; }
  .text--teal.darken-3 { color: #00695C; }
  .text--teal.darken-4 { color: #004D40; }
  .text--teal.accent-1 { color: #A7FFEB; }
  .text--teal.accent-2 { color: #64FFDA; }
  .text--teal.accent-3 { color: #1DE9B6; }
  .text--teal.accent-4 { color: #00BFA5; }

  .text--green { color: #4CAF50; color: #4CAF50; }
  .text--green.lighten-5 { color: #E8F5E9; }
  .text--green.lighten-4 { color: #C8E6C9; }
  .text--green.lighten-3 { color: #A5D6A7; }
  .text--green.lighten-2 { color: #81C784; }
  .text--green.lighten-1 { color: #66BB6A; }
  .text--green.darken-1 { color: #43A047; }
  .text--green.darken-2 { color: #388E3C; }
  .text--green.darken-3 { color: #2E7D32; }
  .text--green.darken-4 { color: #1B5E20; }
  .text--green.accent-1 { color: #B9F6CA; }
  .text--green.accent-2 { color: #69F0AE; }
  .text--green.accent-3 { color: #00E676; }
  .text--green.accent-4 { color: #00C853; }
  
  .text--light-green  { color: #8BC34A; }
  .text--light-green.lighten-5 { color: #F1F8E9; }
  .text--light-green.lighten-4 { color: #DCEDC8; }
  .text--light-green.lighten-3 { color: #C5E1A5; }
  .text--light-green.lighten-2 { color: #AED581; }
  .text--light-green.lighten-1 { color: #9CCC65; }
  .text--light-green.darken-1 { color: #7CB342; }
  .text--light-green.darken-2 { color: #689F38; }
  .text--light-green.darken-3 { color: #558B2F; }
  .text--light-green.darken-4 { color: #33691E; }
  .text--light-green.accent-1 { color: #CCFF90; }
  .text--light-green.accent-2 { color: #B2FF59; }
  .text--light-green.accent-3 { color: #76FF03; }
  .text--light-green.accent-4 { color: #64DD17; }

  .text--lime { color: #CDDC39; }
  .text--lime.lighten-5 { color: #F9FBE7; }
  .text--lime.lighten-4 { color: #F0F4C3; }
  .text--lime.lighten-3 { color: #E6EE9C; }
  .text--lime.lighten-2 { color: #DCE775; }
  .text--lime.lighten-1 { color: #D4E157; }
  .text--lime.darken-1 { color: #C0CA33; }
  .text--lime.darken-2 { color: #AFB42B; }
  .text--lime.darken-3 { color: #9E9D24; }
  .text--lime.darken-4 { color: #827717; }
  .text--lime.accent-1 { color: #F4FF81; }
  .text--lime.accent-2 { color: #EEFF41; }
  .text--lime.accent-3 { color: #C6FF00; }
  .text--lime.accent-4 { color: #AEEA00; }
  
  .text--yellow { color: #FFEB3B; }
  .text--yellow.lighten-5 { color: #FFFDE7; }
  .text--yellow.lighten-4 { color: #FFF9C4; }
  .text--yellow.lighten-3 { color: #FFF59D; }
  .text--yellow.lighten-2 { color: #FFF176; }
  .text--yellow.lighten-1 { color: #FFEE58; }
  .text--yellow.darken-1 { color: #FDD835; }
  .text--yellow.darken-2 { color: #FBC02D; }
  .text--yellow.darken-3 { color: #F9A825; }
  .text--yellow.darken-4 { color: #F57F17; }
  .text--yellow.accent-1 { color: #FFFF8D; }
  .text--yellow.accent-2 { color: #FFFF00; }
  .text--yellow.accent-3 { color: #FFEA00; }
  .text--yellow.accent-4 { color: #FFD600; }

  .text--amber { color: #FFC107; }
  .text--amber.lighten-5 { color: #FFF8E1; }
  .text--amber.lighten-4 { color: #FFECB3; }
  .text--amber.lighten-3 { color: #FFE082; }
  .text--amber.lighten-2 { color: #FFD54F; }
  .text--amber.lighten-1 { color: #FFCA28; }
  .text--amber.darken-1 { color: #FFB300; }
  .text--amber.darken-2 { color: #FFA000; }
  .text--amber.darken-3 { color: #FF8F00; }
  .text--amber.darken-4 { color: #FF6F00; }
  .text--amber.accent-1 { color: #FFE57F; }
  .text--amber.accent-2 { color: #FFD740; }
  .text--amber.accent-3 { color: #FFC400; }
  .text--amber.accent-4 { color: #FFAB00; }

  .text--orange { color: #FF9800; }
  .text--orange.lighten-5 { color: #FFF3E0; }
  .text--orange.lighten-4 { color: #FFE0B2; }
  .text--orange.lighten-3 { color: #FFCC80; }
  .text--orange.lighten-2 { color: #FFB74D; }
  .text--orange.lighten-1 { color: #FFA726; }
  .text--orange.darken-1 { color: #FB8C00; }
  .text--orange.darken-2 { color: #F57C00; }
  .text--orange.darken-3 { color: #EF6C00; }
  .text--orange.darken-4 { color: #E65100; }
  .text--orange.accent-1 { color: #FFD180; }
  .text--orange.accent-2 { color: #FFAB40; }
  .text--orange.accent-3 { color: #FF9100; }
  .text--orange.accent-4 { color: #FF6D00; }

  .text--deep-orange { color: #FF5722; }
  .text--deep-orange.lighten-5 { color: #FBE9E7; }
  .text--deep-orange.lighten-4 { color: #FFCCBC; }
  .text--deep-orange.lighten-3 { color: #FFAB91; }
  .text--deep-orange.lighten-2 { color: #FF8A65; }
  .text--deep-orange.lighten-1 { color: #FF7043; }
  .text--deep-orange.darken-1 { color: #F4511E; }
  .text--deep-orange.darken-2 { color: #E64A19; }
  .text--deep-orange.darken-3 { color: #D84315; }
  .text--deep-orange.darken-4 { color: #BF360C; }
  .text--deep-orange.accent-1 { color: #FF9E80; }
  .text--deep-orange.accent-2 { color: #FF6E40; }
  .text--deep-orange.accent-3 { color: #FF3D00; }
  .text--deep-orange.accent-4 { color: #DD2C00; }

  .text--brown { color: #795548; }
  .text--brown.lighten-5 { color: #EFEBE9; }
  .text--brown.lighten-4 { color: #D7CCC8; }
  .text--brown.lighten-3 { color: #BCAAA4; }
  .text--brown.lighten-2 { color: #A1887F; }
  .text--brown.lighten-1 { color: #8D6E63; }
  .text--brown.darken-1 { color: #6D4C41; }
  .text--brown.darken-2 { color: #5D4037; }
  .text--brown.darken-3 { color: #4E342E; }
  .text--brown.darken-4 { color: #3E2723; }
  
  .text--blue-grey { color: #607D8B; }
  .text--blue-grey.lighten-5 { color: #ECEFF1; }
  .text--blue-grey.lighten-4 { color: #CFD8DC; }
  .text--blue-grey.lighten-3 { color: #B0BEC5; }
  .text--blue-grey.lighten-2 { color: #90A4AE; }
  .text--blue-grey.lighten-1 { color: #78909C; }
  .text--blue-grey.darken-1 { color: #546E7A; }
  .text--blue-grey.darken-2 { color: #455A64; }
  .text--blue-grey.darken-3 { color: #37474F; }
  .text--blue-grey.darken-4 { color: #263238; }

  .text--grey { color: #9E9E9E; }
  .text--grey.lighten-5 { color: #FAFAFA; }
  .text--grey.lighten-4 { color: #F5F5F5; }
  .text--grey.lighten-3 { color: #EEEEEE; }
  .text--grey.lighten-2 { color: #E0E0E0; }
  .text--grey.lighten-1 { color: #BDBDBD; }
  .text--grey.darken-1 { color: #757575; }
  .text--grey.darken-2 { color: #616161; }
  .text--grey.darken-3 { color: #424242; }
  .text--grey.darken-4 { color: #212121; }

</style>